//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { RepeatDetailsItem } from './RepeatDetailsItem';

export class TestMileageInputItem extends ItemBase {
    RepeatDetails: RepeatDetailsItem | null = null;
    TeacherIndex: number | null = null;
    Vehicle: string | null = null;
    Date: string | null = null;
    Destination: string | null = null;
    Distance: number | null = null;
    DurationInMinutes: number | null = null;
    Notes: string | null = null;
    Odometer: string | null = null;

    constructor(initializer?: Partial<TestMileageInputItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TestMileageInputItem";
}
